import { HttpErrorResponse, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StorageManagerService } from '../services';
import { AuthenticationService } from '../services/authentication.service';
import { EMPTY } from 'rxjs';
import { AppGlobals } from '../globals/appGlobals';
import { isDevMode } from '@angular/core';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  modifiedHeader: HttpHeaders;
  constructor (private router: Router, private toastr: ToastrService, private storage: StorageManagerService, private authenticationService: AuthenticationService, private appGlobals: AppGlobals) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const req = request.clone();

    return next.handle(req).pipe(
      retry(0),
      catchError((error: HttpErrorResponse) => {
        //Code to Handle Timeout Error
        if (error.status === 499 || JSON.stringify(error).includes('Error Code:499')) {
          console.error('TimeourError Occured - ' + error.message);
          this.toastr.success('Request has been submitted to process further', '', { closeButton: true });
          return EMPTY;
        }
        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {

          // client-side error
          if (isDevMode()) {
            errorMessage = `Error: ${ error.error.message }`;
          } else {
            errorMessage = this.appGlobals.GENERIC_ERROR_MSG;
          }
        } else {

          // server-side error
          if (error.status === 401) {

            const authData = this.storage.read('userData');

            if (authData) {

              this.authenticationService.setHeader();
            } 

            if (isDevMode()) {
              errorMessage = `Error Code: ${ error.status }\nMessage: ${ error.message }`;
              this.toastr.error('Http call failed with status 401');
              this.router.navigate(['/error', { message: errorMessage, code: error.status }]);
            } else {

              this.toastr.error(this.appGlobals.GENERIC_ERROR_MSG);
              this.router.navigate(['/error', { message: this.appGlobals.GENERIC_ERROR_MSG }]);
            }

            return throwError(EMPTY);
          } else {

            if (isDevMode()) {
              errorMessage = `Error Code: ${ error.status }\nMessage: ${ error.message }`;
              this.toastr.error(errorMessage);
              this.router.navigate(['/error', { message: errorMessage, code: error.status }]);
            } else {

              this.toastr.error(this.appGlobals.GENERIC_ERROR_MSG);
              this.router.navigate(['/error', { message: this.appGlobals.GENERIC_ERROR_MSG }]);
            }
          }
        }
        return throwError(errorMessage);
      })
    );
  }
}
